/* FoldifyCase blog post behaviour (2026-10-26, liquid glass redesign).
   Replaces snippets/fc-blog-engage.liquid. Strings come from the JSON
   script #fc-article-cfg rendered by sections/main-article.liquid (en/de/es),
   so nothing here is English-only. Each feature runs in its own try/catch. */
(function () {
  'use strict';

  function init() {
    var article = document.getElementById('fc-article');
    if (!article || article.getAttribute('data-fa-init') === '1') return;
    article.setAttribute('data-fa-init', '1');

    var cfg = {};
    try { cfg = JSON.parse((document.getElementById('fc-article-cfg') || {}).textContent || '{}'); } catch (e) {}
    var T = cfg.t || {};
    var t = function (k, d) { return T[k] || d; };
    var content = article.querySelector('.fc-content');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); };

    /* ---------- reading progress ---------- */
    try {
      var fill = document.getElementById('fc-progress-fill');
      if (fill) {
        var prog = function () {
          var r = article.getBoundingClientRect();
          var total = r.height - window.innerHeight;
          var done = Math.min(Math.max(-r.top, 0), Math.max(total, 0));
          fill.style.width = (total > 0 ? (done / total) * 100 : 0) + '%';
        };
        window.addEventListener('scroll', prog, { passive: true });
        window.addEventListener('resize', prog);
        prog();
      }
    } catch (e) {}

    /* ---------- long short answer: phone clamp toggle ---------- */
    try {
      var more = article.querySelector('.fc-answer__more');
      if (more) {
        more.addEventListener('click', function () {
          var box = more.closest('.fc-answer');
          var open = !box.classList.contains('is-open');
          box.classList.toggle('is-open', open);
          more.setAttribute('aria-expanded', String(open));
          more.textContent = open ? (more.getAttribute('data-less') || '') : (more.getAttribute('data-more') || '');
        });
      }
    } catch (e) {}

    /* ---------- tables: glass wrapper, labels, cards on phones ----------
       Every table gets a wrapper (glass card + sideways scroll as the last
       resort). Tables with 3+ columns also get data-label on each cell so the
       phone CSS can stack every row into a labelled card instead of letting
       it run off the screen. */
    try {
      if (content) {
        var tables = content.querySelectorAll('table');
        for (var ti = 0; ti < tables.length; ti++) {
          var tb = tables[ti];
          var wrap = document.createElement('div');
          wrap.className = 'fc-tablewrap';
          tb.parentNode.insertBefore(wrap, tb);
          wrap.appendChild(tb);
          var headRow = null;
          var thead = tb.querySelector('thead');
          if (thead) {
            var hr = thead.querySelectorAll('tr');
            headRow = hr.length ? hr[hr.length - 1] : null;
          } else {
            var first = tb.querySelector('tr');
            if (first && first.querySelectorAll('td').length === 0 && first.querySelectorAll('th').length > 1) {
              headRow = first;
              first.classList.add('fc-thead-row');
            }
          }
          if (!headRow) continue;
          var labels = [];
          var hc = headRow.children;
          for (var h = 0; h < hc.length; h++) {
            var span = parseInt(hc[h].getAttribute('colspan'), 10) || 1;
            var txt = (hc[h].textContent || '').replace(/\s+/g, ' ').trim();
            for (var s = 0; s < span; s++) labels.push(txt);
          }
          if (labels.length < 3) continue;
          var rows = tb.querySelectorAll('tr');
          for (var r = 0; r < rows.length; r++) {
            if (rows[r] === headRow || rows[r].parentNode === thead) continue;
            var col = 0;
            var cells = rows[r].children;
            for (var c = 0; c < cells.length; c++) {
              if (labels[col]) {
                cells[c].setAttribute('data-label', labels[col]);
                /* one wrapper per cell, so "Yes <em>(last supported)</em>"
                   stays in the value column of the phone card grid */
                if (c > 0 && !(cells[c].childNodes.length === 1 && cells[c].firstElementChild && cells[c].firstElementChild.className === 'fc-cell')) {
                  var cw = document.createElement('span');
                  cw.className = 'fc-cell';
                  while (cells[c].firstChild) cw.appendChild(cells[c].firstChild);
                  cells[c].appendChild(cw);
                }
              }
              col += parseInt(cells[c].getAttribute('colspan'), 10) || 1;
            }
          }
          wrap.classList.add('is-cards');
        }
      }
    } catch (e) {}

    /* ---------- table of contents ---------- */
    try {
      if (content) {
        var heads = content.querySelectorAll('h2');
        if (heads.length >= 3) {
          var nav = document.createElement('nav');
          nav.className = 'fc-toc';
          nav.setAttribute('aria-label', t('toc', 'In this article'));
          var links = {}, order = [], items = '';
          for (var i = 0; i < heads.length; i++) {
            var hd = heads[i];
            if (!hd.id) {
              var slug = (hd.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 40);
              hd.id = 'sec-' + i + (slug ? '-' + slug : '');
            }
            order.push(hd.id);
            items += '<li><a href="#' + hd.id + '" data-toc="' + hd.id + '">' + esc((hd.textContent || '').trim()) + '</a></li>';
          }
          nav.innerHTML = '<div class="fc-toc__head"><p class="fc-toc__title">' + esc(t('toc', 'In this article')) + '</p>' +
            '<button type="button" class="fc-toc__toggle" aria-expanded="true" aria-label="' + esc(t('tocToggle', 'Show or hide the contents')) + '">' +
            '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>' +
            '<ul class="fc-toc__list">' + items + '</ul>';
          var slot = article.querySelector('[data-fc-toc-slot]');
          var railMode = !!(slot && window.matchMedia('(min-width: 1200px)').matches);
          if (railMode) slot.appendChild(nav); else content.parentNode.insertBefore(nav, content);

          var as = nav.querySelectorAll('a[data-toc]');
          for (var j = 0; j < as.length; j++) {
            links[as[j].getAttribute('data-toc')] = as[j];
            as[j].addEventListener('click', function (e) {
              var id = this.getAttribute('data-toc');
              var target = document.getElementById(id);
              if (!target) return;
              e.preventDefault();
              target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
              target.setAttribute('tabindex', '-1');
              try { target.focus({ preventScroll: true }); } catch (ef) {}
              if (history.replaceState) history.replaceState(null, '', '#' + id);
            });
          }
          try {
            if (location.hash && location.hash.indexOf('#sec-') === 0) {
              var t0 = document.getElementById(location.hash.slice(1));
              if (t0) t0.scrollIntoView();
            }
          } catch (e0) {}
          var toggle = nav.querySelector('.fc-toc__toggle');
          var setCollapsed = function (cl) { nav.classList.toggle('is-collapsed', cl); toggle.setAttribute('aria-expanded', String(!cl)); };
          if (!railMode) {
            nav.querySelector('.fc-toc__head').addEventListener('click', function () { setCollapsed(!nav.classList.contains('is-collapsed')); });
            if (window.innerWidth <= 749) setCollapsed(true);
          }
          if ('IntersectionObserver' in window) {
            var setActive = function (id) {
              var idx = order.indexOf(id);
              for (var q = 0; q < order.length; q++) {
                var a = links[order[q]];
                if (!a) continue;
                a.classList.toggle('is-active', q === idx);
                a.classList.toggle('is-done', q < idx);
              }
            };
            var hObs = new IntersectionObserver(function (en) {
              for (var k = 0; k < en.length; k++) if (en[k].isIntersecting) setActive(en[k].target.id);
            }, { rootMargin: '0px 0px -75% 0px', threshold: 0 });
            for (var m = 0; m < heads.length; m++) hObs.observe(heads[m]);
          }
        }
      }
    } catch (e) {}

    /* ---------- FAQ accordions ----------
       h3 + consecutive <p> answers under any FAQ H2 become tap-to-open
       panels. Answers stay in the DOM; collapsed ones use
       hidden="until-found" so Ctrl+F and #:~:text= links open them. Without
       beforematch (Safari) every panel starts open. */
    try {
      var canCollapse = 'onbeforematch' in document.body;
      var vhA = window.innerHeight || 800;
      var hashEl = null;
      try { if (location.hash && location.hash.length > 1) hashEl = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch (eh) {}
      var setPanel = function (btn, panel, open) {
        var inner = panel.firstElementChild;
        btn.setAttribute('aria-expanded', String(open));
        if (panel._fcT) { clearTimeout(panel._fcT); panel._fcT = null; }
        if (open) {
          if (inner) inner.removeAttribute('hidden');
          panel.classList.add('is-open');
        } else {
          panel.classList.remove('is-open');
          panel._fcT = setTimeout(function () { if (inner) inner.setAttribute('hidden', canCollapse ? 'until-found' : ''); panel._fcT = null; }, 400);
        }
      };
      var faqRe = new RegExp(cfg.faqRe || '(\\bfaqs?\\b|frequently asked|häufige fragen|preguntas frecuentes)', 'i');
      var h2s = article.querySelectorAll('.fc-content h2');
      var accN = 0;
      for (var f = 0; f < h2s.length; f++) {
        if (!faqRe.test(h2s[f].textContent || '')) continue;
        var node = h2s[f].nextElementSibling, groups = [], cur = null;
        while (node && node.tagName !== 'H2') {
          if (node.tagName === 'H3') { cur = { q: node, as: [] }; groups.push(cur); }
          else if (cur && node.tagName === 'P') { cur.as.push(node); }
          else { cur = null; }
          node = node.nextElementSibling;
        }
        for (var g = 0; g < groups.length; g++) {
          (function (it, gi) {
            if (!it.as.length) return;
            var open = !canCollapse || gi === 0;
            if (!open) { try { if (it.q.getBoundingClientRect().top < vhA) open = true; } catch (er) {} }
            if (!open && hashEl) {
              for (var c2 = 0; c2 < it.as.length; c2++) if (it.as[c2] === hashEl || it.as[c2].contains(hashEl)) { open = true; break; }
            }
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'fc-acc__btn';
            while (it.q.firstChild) btn.appendChild(it.q.firstChild);
            var ic = document.createElement('span');
            ic.className = 'fc-acc__ic';
            ic.setAttribute('aria-hidden', 'true');
            ic.textContent = '+';
            btn.appendChild(ic);
            it.q.appendChild(btn);
            it.q.classList.add('fc-acc__q');
            var panel = document.createElement('div');
            panel.className = 'fc-acc__panel' + (open ? ' is-open' : '');
            panel.id = 'fc-acc-' + (accN++);
            var inner = document.createElement('div');
            inner.className = 'fc-acc__inner';
            panel.appendChild(inner);
            it.q.parentNode.insertBefore(panel, it.q.nextSibling);
            for (var w = 0; w < it.as.length; w++) inner.appendChild(it.as[w]);
            if (!open) inner.setAttribute('hidden', 'until-found');
            btn.setAttribute('aria-expanded', String(open));
            btn.setAttribute('aria-controls', panel.id);
            if (canCollapse) inner.addEventListener('beforematch', function () { setPanel(btn, panel, true); });
            btn.addEventListener('click', function () { setPanel(btn, panel, btn.getAttribute('aria-expanded') !== 'true'); });
          })(groups[g], g);
        }
      }
    } catch (e) {}

    /* ---------- image lightbox (unlinked content images) ---------- */
    try {
      if (content) {
        var overlay = null, escFn = null;
        var scrollFn = function () { closeLb(); };
        var closeLb = function () {
          if (!overlay) return;
          overlay.remove();
          overlay = null;
          if (escFn) { document.removeEventListener('keydown', escFn); escFn = null; }
          window.removeEventListener('scroll', scrollFn);
        };
        var openLb = function (img) {
          closeLb();
          overlay = document.createElement('div');
          overlay.className = 'fc-lightbox';
          overlay.setAttribute('role', 'dialog');
          overlay.setAttribute('aria-modal', 'true');
          overlay.setAttribute('aria-label', img.alt || t('enlarged', 'Enlarged image'));
          var big = document.createElement('img');
          big.src = img.currentSrc || img.src;
          big.alt = img.alt || '';
          var x = document.createElement('button');
          x.type = 'button';
          x.className = 'fc-lightbox__close';
          x.setAttribute('aria-label', t('close', 'Close'));
          x.innerHTML = '&times;';
          overlay.appendChild(x);
          overlay.appendChild(big);
          overlay.addEventListener('click', closeLb);
          overlay.addEventListener('keydown', function (e) { if (e.key === 'Tab') { e.preventDefault(); x.focus(); } });
          escFn = function (e) { if (e.key === 'Escape') closeLb(); };
          document.addEventListener('keydown', escFn);
          setTimeout(function () { if (overlay) window.addEventListener('scroll', scrollFn, { passive: true }); }, 150);
          document.body.appendChild(overlay);
          x.focus();
        };
        var imgs = content.querySelectorAll('img');
        for (var im = 0; im < imgs.length; im++) {
          (function (img) {
            if (img.closest('a') || img.closest('.fc-acc__panel')) return;
            var wAttr = parseInt(img.getAttribute('width'), 10) || 0;
            if (img.clientWidth < 280 && wAttr < 280) return;
            img.classList.add('fc-zoomable');
            img.addEventListener('click', function () { openLb(img); });
          })(imgs[im]);
        }
      }
    } catch (e) {}

    /* ---------- "Was this guide helpful?" ---------- */
    try {
      var secs = article.querySelectorAll('.fc-content');
      var anchor = secs.length ? secs[secs.length - 1] : null;
      if (anchor) {
        var key = 'fc-vote:' + location.pathname;
        var prior = null;
        try { prior = localStorage.getItem(key); } catch (e3) {}
        var box = document.createElement('div');
        box.className = 'fc-vote';
        box.setAttribute('aria-live', 'polite');
        var thanks = function (v) {
          return '<p class="fc-vote__done" tabindex="-1"><span class="fc-vote__tick" aria-hidden="true">&#10003;</span>' +
            esc(v === 'up' ? t('thanksUp', 'Thanks! Glad this guide helped.') : t('thanksDown', 'Thanks for the feedback. We will keep improving this guide.')) + '</p>';
        };
        if (prior === 'up' || prior === 'down') {
          box.innerHTML = thanks(prior);
        } else {
          box.innerHTML = '<p class="fc-vote__q">' + esc(t('voteQ', 'Was this guide helpful?')) + '</p><div class="fc-vote__row">' +
            '<button type="button" class="fc-vote__btn" data-fc-vote="up">&#128077; ' + esc(t('voteYes', 'Yes, helpful')) + '</button>' +
            '<button type="button" class="fc-vote__btn" data-fc-vote="down">&#128078; ' + esc(t('voteNo', 'Not really')) + '</button></div>';
          box.addEventListener('click', function (e) {
            var b = e.target && e.target.closest ? e.target.closest('[data-fc-vote]') : null;
            if (!b) return;
            var v = b.getAttribute('data-fc-vote');
            try { localStorage.setItem(key, v); } catch (e4) {}
            try { (window.dataLayer = window.dataLayer || []).push({ event: 'fc_blog_vote', fc_vote: v, page_path: location.pathname }); } catch (e5) {}
            try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('fc_blog_vote', { vote: v, path: location.pathname }); } catch (e6) {}
            try { if (typeof window.clarity === 'function') window.clarity('event', 'fc_blog_vote_' + v); } catch (e7) {}
            box.innerHTML = thanks(v);
            var d = box.querySelector('.fc-vote__done');
            if (d) { try { d.focus({ preventScroll: true }); } catch (e8) {} }
          });
        }
        anchor.parentNode.insertBefore(box, anchor.nextSibling);
      }
    } catch (e) {}

    /* ---------- back to top ---------- */
    try {
      if (!document.querySelector('.fc-top')) {
        var top = document.createElement('button');
        top.type = 'button';
        top.className = 'fc-top';
        top.setAttribute('aria-label', t('top', 'Back to top'));
        top.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        document.body.appendChild(top);
        top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); top.blur(); });
        var ticking = false;
        var onScroll = function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            ticking = false;
            var y = window.scrollY || document.documentElement.scrollTop || 0;
            top.classList.toggle('is-show', y > (window.innerHeight || 800) * 1.5);
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    } catch (e) {}

    /* ---------- live prices on the picks and the rail ----------
       Blog pages sit in the page cache long enough for a converted market's
       baked price to drift from the live rate, so re-read /products/x.js and
       format with fcMoney (snippets/fc-money.liquid). A pick that names a
       variant shows that variant's price, otherwise the cheapest one. */
    try {
      var priced = article.querySelectorAll('[data-fc-bgp]');
      if (priced.length && typeof window.fcMoney === 'function') {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        var cache = {};
        var get = function (h) {
          if (!cache[h]) cache[h] = fetch(root + 'products/' + h + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
          return cache[h];
        };
        Array.prototype.forEach.call(priced, function (el) {
          var h = el.getAttribute('data-fc-bgp');
          if (!h) return;
          get(h).then(function (p) {
            if (!p) return;
            var vid = el.getAttribute('data-fc-bgv');
            var price = p.price, was = 0;
            if (vid && p.variants) {
              for (var vi = 0; vi < p.variants.length; vi++) {
                if (String(p.variants[vi].id) === vid) { price = p.variants[vi].price; was = p.variants[vi].compare_at_price || 0; break; }
              }
            }
            var from = (!vid && el.getAttribute('data-fc-bgp-varies') === '1') ? t('from', 'From ') : '';
            var html = esc(from + window.fcMoney(price));
            if (was > price) html += ' <s>' + esc(window.fcMoney(was)) + '</s>';
            if (el.innerHTML !== html) el.innerHTML = html;
          });
        });
      }
    } catch (e) {}

    /* ---------- click tracking (picks + rail) ---------- */
    try {
      article.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('[data-fc-pick], [data-pw-link]') : null;
        if (!a) return;
        var place = a.hasAttribute('data-fc-pick') ? 'top_picks' : 'rail';
        var handle = a.getAttribute('data-fc-pick') || a.getAttribute('data-pw-handle') || '';
        try {
          (window.dataLayer = window.dataLayer || []).push({ event: 'blog_product_click', article_handle: cfg.handle || '', product_handle: handle, placement: place, product_price: parseFloat(a.getAttribute('data-pw-price')) || 0 });
          if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('blog_product_click', { article: cfg.handle || '', product: handle, placement: place });
        } catch (err) {}
      });
    } catch (e) {}

    /* ---------- rail arrows ---------- */
    try {
      var bfc = article.querySelector('.fc-bfc');
      var rail = bfc && bfc.querySelector('.fc-bfc__rail');
      var prev = bfc && bfc.querySelector('.fc-bfc__nav--prev');
      var next = bfc && bfc.querySelector('.fc-bfc__nav--next');
      if (rail && prev && next) {
        var step = function () { var cd = rail.querySelector('.fc-bfc__card'); return cd ? cd.getBoundingClientRect().width + 14 : 240; };
        prev.addEventListener('click', function (e) { e.preventDefault(); rail.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
        next.addEventListener('click', function (e) { e.preventDefault(); rail.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
        var upd = function () {
          var max = rail.scrollWidth - rail.clientWidth - 2;
          prev.classList.toggle('is-off', rail.scrollLeft <= 2);
          next.classList.toggle('is-off', rail.scrollLeft >= max);
        };
        rail.addEventListener('scroll', upd, { passive: true });
        window.addEventListener('resize', upd);
        upd();
      }
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () {
    var a = document.getElementById('fc-article');
    if (a) a.removeAttribute('data-fa-init');
    init();
  });
})();
